<template>
    <div>
        <a-modal
            :maskClosable="false"
            :width="500"
            :visible="isActive"
            :zIndex="80000"
            v-model="isActive"
            :footer="null"
            :title="'Mesa ' + getTableNumberFromBill(fromBillId)"
            >

                <!-- <div slot="title" class="text-center">
                    <span> Confirme a sua intenção </span>
                </div>

                <div class="vx-row">
                    <div class="w-full">
                        <p v-if="!toBillId"> Deseja realmente <span class="text-primary"> <strong> TRANSFERIR </strong> </span> a mesa {{ getTableNumberFromBill(fromBillId) }} para a mesa {{ getTableNumberFromTable(toTableId) }}?  </p>
                        <p v-else> Deseja realmente <span class="text-primary"> <strong> UNIR </strong> </span> a mesa {{ getTableNumberFromBill(fromBillId) }} com a mesa {{ getTableNumberFromBill(toBillId) }}?  </p>
                        <p class="mt-4"> Lembre-se: esta ação é irrevesível. </p>
                    </div>
                </div>

                <div class="vx-row">
                    
                </div>

                <div slot="footer">
                    <vs-button type="relief" @click="transferTable" v-if="!toBillId"> Transferir Mesa </vs-button>
                    <vs-button type="relief" @click="mergeTable" v-else> Unir Mesas </vs-button>
                    <vs-button type="border" @click="isActive = false"> Cancelar </vs-button>
                </div> -->

                <!-- <div class="flex">
                    <vx-card 
                        @click="transferTable"
                        class="w-full text-center justify-center border border-dashed d-theme-border-grey-light border-r-2 border-b-2 border-l-2 border-t-2 mr-4 cursor-pointer">
                        <span class="vx-row text-center justify-center font-bold"> Transferência de mesa </span>
                        <span class="vx-row justify-center mb-4"> Mesa {{ getTableNumberFromBill(fromBillId) }} para a mesa {{ getTableNumberFromBill(toBillId) }} </span>

                        <lottie class="center" :options="animations.transfer" :height="100" :width="100"/>
                    </vx-card>

                    <vx-card 
                        class="w-full text-center justify-center border border-dashed d-theme-border-grey-light border-r-2 border-b-2 border-l-2 border-t-2 cursor-pointer">
                        <span class="vx-row text-center justify-center font-bold"> Junção de mesas </span>
                        <span class="vx-row justify-center mb-4"> Mesa {{ getTableNumberFromBill(fromBillId) }} com a mesa {{ getTableNumberFromBill(toBillId) }} </span>

                        <lottie class="center" :options="animations.merge" :height="100" :width="100"/>
                    </vx-card>
                </div> -->

                <div class="vx-row ml-1 mr-1">
                    <span> Mesa </span>
                    <v-select class="w-full" :options="tables" :clearable="false" v-model="selectedToTable" />
                </div>

                <div class="vx-row mt-4" v-if="!selectedToTable.billId || !selectedToTable">
                    <vs-button class="w-full ml-4 mr-4" type="relief" size="large" :disabled="selectedToTable.billId || !selectedToTable" @click="transferTable(selectedToTable.value)"> 
                        <a-icon type="double-right" class="mt-2" style="font-size: 14px" />
                        <span class="text-sm"> TRANSFERIR PARA A MESA {{ selectedToTable.tableNumber }}  </span>
                    </vs-button>
                </div>

                <!-- <vs-divider border-style="dashed" /> -->

                <div class="vx-row mt-4" v-if="selectedToTable.billId || !selectedToTable">
                    <vs-button class="w-full ml-4 mr-4" type="relief" size="large" :disabled="!selectedToTable.billId || !selectedToTable" @click="mergeTable(selectedToTable.billId)"> 
                        <a-icon type="shrink" class="mt-2" style="font-size: 16px" />
                        <span class="text-sm"> UNIR COM A MESA {{ selectedToTable.tableNumber }}  </span>
                    </vs-button>
                </div>

        </a-modal>
    </div>
</template>

<script>
    import { httpsCallable } from "@/firebase/functions";
    // import Lottie from 'vue-lottie';
    import { fileTransfer } from '@/assets/animations/fileTransfer.js'
    import { fileMerge }    from '@/assets/animations/fileMerge.js'
    import vSelect from 'vue-select'

    export default {
        props : {
            visible : {
                required : true,
                type: Boolean
            },
            bills : {
                required : true,
                type: Array
            },
            fromBillId : {
                required : true,
                type : String
            },
            toBillId : {
                required : true,
                type : String
            },
            toTableId : {
                required : true,
                type: String
            }
        },

        components : {
            // Lottie,
            vSelect
        },

        data () {
            return {
                animations : {
                    transfer : 
                        { animationData : fileTransfer},
                    merge : {
                        animationData : fileMerge
                    }
                },
                isActive : false,
                companyId : this.$store.getters.getCompanyID,
                selectedToTable : ''
            }
        },

        created () {
            this.isActive = this.visible
        },

        watch : {
            visible (newValue) {
                this.isActive = newValue
            },

            isActive (newValue) {
                this.$emit('close', newValue)
                if(!newValue) 
                    this.selectedToTable = ''
            },

            bills (val) {
                // if(!this.selectedToTable) {
                //     if(this.bills.length)
                //         this.selectedToTable = { 
                //             label : 'Mesa ' + this.bills[0].table.number,
                //             value : this.bills[0].table.id,
                //             billId : this.bills[0].id || null
                //          }
                // }
            }
        },

        computed : {
            tables () {
                let obj = []
                this.bills.forEach(bill => {
                    let billProp = bill.id ? bill.id : null
                    if(bill.id != this.fromBillId)
                        obj.push(
                            { label : 'Mesa ' + bill.table.number, value : bill.table.id, billId: billProp, tableNumber : bill.table.number }
                        )
                })

                return obj
            }
        },

        methods : {
            getTableNumberFromTable (id) {
                let bill = this.bills.find(bill => id == bill.table.id)

                return bill ? bill.table.number : ''
            },

            getTableNumberFromBill (id) {
                let bill = this.bills.find(bill => id == bill.id)
                return bill ? bill.table.number : ''
            },

            async transferTable (toTableId) {
                try {
                    this.$vs.loading()
                    let call = httpsCallable('transferTable')
                    // let transferTable = await call({ companyId : this.companyId, billId : this.fromBillId, toTableId : this.toTableId })
                    let transferTable = await call({ companyId : this.companyId, billId : this.fromBillId, toTableId : toTableId })
                } catch (err) {
                    this.$error({
                        zIndex: 999999,
                        title: 'Erro!',
                        content: err.message
                    })
                } finally {
                    this.$vs.loading.close()
                    this.isActive = false;
                }
            },

            async mergeTable (toBillId) {
                try {
                    this.$vs.loading()
                    let call = httpsCallable('mergeTable')
                    // let transferTable = await call({ companyId : this.companyId, billId : this.fromBillId, toBillId : this.toBillId })
                    let mergeTable = await call({ companyId : this.companyId, billId : this.fromBillId, toBillId : toBillId })
                } catch (err) {
                    this.$error({
                        zIndex: 999999,
                        title: 'Erro!',
                        content: err.message
                    })
                } finally {
                    this.$vs.loading.close()
                    this.isActive = false;
                }
            }
        }
    }
</script>
